var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c("b-list-group-item", [_vm._v("Cras justo odio")]),
                    _vm._v(" "),
                    _c("b-list-group-item", [
                      _vm._v("Dapibus ac facilisis in")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [_vm._v("Morbi leo risus")]),
                    _vm._v(" "),
                    _c("b-list-group-item", [
                      _vm._v("Porta ac consectetur ac")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [_vm._v("Vestibulum at eros")])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c("b-list-group-item", [_vm._v("Cras justo odio")]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { active: "" } }, [
                      _vm._v("Dapibus ac facilisis in")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [_vm._v("Morbi leo risus")]),
                    _vm._v(" "),
                    _c("b-list-group-item", [
                      _vm._v("Porta ac consectetur ac")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [_vm._v("Vestibulum at eros")])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c("b-list-group-item", { attrs: { disabled: "" } }, [
                      _vm._v("Cras justo odio")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [
                      _vm._v("Dapibus ac facilisis in")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [_vm._v("Morbi leo risus")]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { disabled: "" } }, [
                      _vm._v("Porta ac consectetur ac")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [_vm._v("Vestibulum at eros")])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c("b-list-group-item", { attrs: { href: "#some-link" } }, [
                      _vm._v("Awesome link")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", active: "" } },
                      [_vm._v("Link with active state")]
                    ),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { href: "#" } }, [
                      _vm._v("Action links are easy")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#foobar", disabled: "" } },
                      [_vm._v("Disabled link")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c("b-list-group-item", { attrs: { button: "" } }, [
                      _vm._v("Button item")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { button: "" } }, [
                      _vm._v("I am a button")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { button: "", disabled: "" } },
                      [_vm._v("Disabled button")]
                    ),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { button: "" } }, [
                      _vm._v("This is a button too")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c("b-list-group-item", [
                      _vm._v("Default list group item")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { variant: "primary" } }, [
                      _vm._v("Primary list group item")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { variant: "secondary" } },
                      [_vm._v("Secondary list group item")]
                    ),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { variant: "success" } }, [
                      _vm._v("Success list group item")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { variant: "danger" } }, [
                      _vm._v("Danger list group item")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { variant: "warning" } }, [
                      _vm._v("Warning list group item")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { variant: "info" } }, [
                      _vm._v("Info list group item")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { variant: "light" } }, [
                      _vm._v("Light list group item")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", { attrs: { variant: "dark" } }, [
                      _vm._v("Dark list group item")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c("b-list-group-item", { attrs: { href: "#" } }, [
                      _vm._v("Default list group item")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", variant: "primary" } },
                      [_vm._v("Primary list group item")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", variant: "secondary" } },
                      [_vm._v("Secondary list group item")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", variant: "success" } },
                      [_vm._v("Success list group item")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", variant: "danger" } },
                      [_vm._v("Danger list group item")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", variant: "warning" } },
                      [_vm._v("Warning list group item")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", variant: "info" } },
                      [_vm._v("Info list group item")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", variant: "light" } },
                      [_vm._v("Light list group item")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      { attrs: { href: "#", variant: "dark" } },
                      [_vm._v("Dark list group item")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c(
                      "b-list-group-item",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _vm._v(
                          "\n                            Cras justo odio\n                            "
                        ),
                        _c(
                          "b-badge",
                          { attrs: { variant: "primary", pill: "" } },
                          [_vm._v("14")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _vm._v(
                          "\n                            Dapibus ac facilisis in\n                            "
                        ),
                        _c(
                          "b-badge",
                          { attrs: { variant: "primary", pill: "" } },
                          [_vm._v("2")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _vm._v(
                          "\n                            Morbi leo risus\n                            "
                        ),
                        _c(
                          "b-badge",
                          { attrs: { variant: "primary", pill: "" } },
                          [_vm._v("1")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 mb-5" },
              [
                _c(
                  "b-card-group",
                  { attrs: { deck: "" } },
                  [
                    _c(
                      "b-card",
                      { attrs: { header: "Card with list group" } },
                      [
                        _c(
                          "b-list-group",
                          [
                            _c("b-list-group-item", { attrs: { href: "#" } }, [
                              _vm._v("Cras justo odio")
                            ]),
                            _vm._v(" "),
                            _c("b-list-group-item", { attrs: { href: "#" } }, [
                              _vm._v("Dapibus ac facilisis in")
                            ]),
                            _vm._v(" "),
                            _c("b-list-group-item", { attrs: { href: "#" } }, [
                              _vm._v("Vestibulum at eros")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-text mt-2" }, [
                          _vm._v(
                            "\n                            Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla tempor. Laborum\n                            consequat non elit enim exercitation cillum aliqua consequat id aliqua. Esse ex consectetur\n                            mollit voluptate est in duis laboris ad sit ipsum anim Lorem.\n                            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        attrs: {
                          "no-body": "",
                          header: "Card with flush list group"
                        }
                      },
                      [
                        _c(
                          "b-list-group",
                          { attrs: { flush: "" } },
                          [
                            _c("b-list-group-item", { attrs: { href: "#" } }, [
                              _vm._v("Cras justo odio")
                            ]),
                            _vm._v(" "),
                            _c("b-list-group-item", { attrs: { href: "#" } }, [
                              _vm._v("Dapibus ac facilisis in")
                            ]),
                            _vm._v(" "),
                            _c("b-list-group-item", { attrs: { href: "#" } }, [
                              _vm._v("Vestibulum at eros")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-card-body", [
                          _vm._v(
                            "\n                            Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla tempor. Laborum\n                            consequat non elit enim exercitation cillum aliqua consequat id aliqua. Esse ex consectetur\n                            mollit voluptate est in duis laboris ad sit ipsum anim Lorem.\n                            "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  { attrs: { horizontal: "" } },
                  [
                    _c("b-list-group-item", [_vm._v("Cras justo ")]),
                    _vm._v(" "),
                    _c("b-list-group-item", [
                      _vm._v("Dapibus ac facilisis in")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [_vm._v("Morbi leo risus")])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  { attrs: { horizontal: "md" } },
                  [
                    _c("b-list-group-item", [_vm._v("Cras justo")]),
                    _vm._v(" "),
                    _c("b-list-group-item", [
                      _vm._v("Dapibus ac facilisis in")
                    ]),
                    _vm._v(" "),
                    _c("b-list-group-item", [_vm._v("Morbi leo risus")])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 mb-5" },
              [
                _c(
                  "b-list-group",
                  [
                    _c(
                      "b-list-group-item",
                      {
                        staticClass: "flex-column align-items-start",
                        attrs: { href: "#", active: "" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex w-100 justify-content-between"
                          },
                          [
                            _c("h5", { staticClass: "mb-1" }, [
                              _vm._v("List group item heading")
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("3 days ago")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-1" }, [
                          _vm._v(
                            "\n                            Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("small", [_vm._v("Donec id elit non mi porta.")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      {
                        staticClass: "flex-column align-items-start",
                        attrs: { href: "#" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex w-100 justify-content-between"
                          },
                          [
                            _c("h5", { staticClass: "mb-1" }, [
                              _vm._v("List group item heading")
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v("3 days ago")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-1" }, [
                          _vm._v(
                            "\n                            Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v("Donec id elit non mi porta.")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      {
                        staticClass: "flex-column align-items-start",
                        attrs: { href: "#", disabled: "" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex w-100 justify-content-between"
                          },
                          [
                            _c("h5", { staticClass: "mb-1" }, [
                              _vm._v("Disabled List group item")
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v("3 days ago")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-1" }, [
                          _vm._v(
                            "\n                            Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v("Donec id elit non mi porta.")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("ListGroup")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e6fd801", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6fd801","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListGroup.vue
// module id = null
// module chunks = 